import { apiRequest } from './api'
import type {
  Supplier,
  ListSuppliersParams,
  ListSuppliersResponse,
  UpdateSupplierData,
  CreateSupplierData,
  CreateSupplierResponse,
} from '@/types'

// List suppliers with pagination
export async function listSuppliers(
  params: ListSuppliersParams
): Promise<ListSuppliersResponse> {
  const queryParams = new URLSearchParams()

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      queryParams.set(key, String(value))
    }
  })

  return apiRequest<ListSuppliersResponse>(`/suppliers/list?${queryParams}`)
}

// Get single supplier by ID
export async function getSupplier(id: string): Promise<Supplier> {
  return apiRequest<Supplier>(`/suppliers/get/${encodeURIComponent(id)}`)
}

// Update supplier
export async function updateSupplier(
  id: string,
  data: UpdateSupplierData
): Promise<Supplier> {
  return apiRequest<Supplier>(`/suppliers/update/${encodeURIComponent(id)}`, {
    method: 'PUT',
    body: JSON.stringify(data),
  })
}

// Create supplier (or return existing if duplicate name)
export async function createSupplier(
  data: CreateSupplierData
): Promise<CreateSupplierResponse> {
  return apiRequest<CreateSupplierResponse>('/suppliers/create', {
    method: 'POST',
    body: JSON.stringify(data),
  })
}
